const ITEMS = [
  "Play-Based Learning",
  "Safe & Hygienic Campus",
  "Certified Early Educators",
  "Holistic Child Development",
  "Creative Arts & Movement",
  "Phonics & Language Mastery",
];

export const Marquee = () => (
  <div className="relative py-6 overflow-hidden">
    <div className="rotate-[-1.2deg] w-[104%] -ml-[2%] bg-sage text-cream py-4 shadow-[0_16px_40px_rgba(45,106,79,0.25)]">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <ul key={copy} aria-hidden={copy === 1} className="flex items-center shrink-0">
            {ITEMS.map((item) => (
              <li key={item} className="flex items-center">
                <span className="font-play font-medium text-lg sm:text-xl whitespace-nowrap px-6">
                  {item}
                </span>
                <span className="w-2.5 h-2.5 rounded-full bg-sun shrink-0" />
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  </div>
);
